/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import useBreakpoint from "hooks/useBreakpoint";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "store";
import ProfileDrawer from "./ProfileDrawer";
import requestService from "api/request";
import { Dropdown, notification } from "antd";
import { useTranslation } from "react-i18next";

const Header = () => {
  const breakpoint = useBreakpoint();
  const { user, appGlobal } = useAppSelector((state) => state.app) as any;
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const { t, i18n } = useTranslation();

  const getLang = (lang: string) => {
    if (lang === "en") return "/img/united-kingdom.png";
    if (lang === "vi") return "/img/vietnam.png";
    if (lang === "cn") return "/img/china.png";
    if (lang === "ko") return "/img/south-korea.png";
    if (lang === "thai") return "/img/thailand.png";
    if (lang === "sin") return "/img/singapore.png";
    if (lang === "ja") return "/img/japan.png";
    if (lang === "cam") return "/img/cambodia.png";
    if (lang === "ms") return "https://img.icons8.com/?size=100&id=nQtyhesxmxhM&format=png&color=000000";
    return "/img/vietnam.png";
  };

  return (
    <div className="sticky-header min-h-[70px]">
      <ProfileDrawer
        onClose={() => setIsOpenProfile(false)}
        open={isOpenProfile}
      />
      <div className="global-theme" style={{ display: "" }}>
        <header className="header-box vi">
          {/**/}
          <div
            data-micro-type="Header"
            className="micro micro-dark"
            data-micro-id={"052785121"}
          >
            <div
              data-v-0408d032=""
              id="MicroHeaderFrame"
              className="micro-header micro-app-hide leading-140%"
            >
              <div
                data-v-0408d032=""
                className="relative z-1 flex h-[70px] w-full box-border items-center px-24px text-14px text-primaryText md:h-64px lt-md:px-16px"
              >
                <a
                  data-v-0408d032=""
                  className="text-primaryText micro-logo w-80px h-24px !md:w-103px !md:h-32px mr-20px"
                  href="/"
                  target="_self"
                >
                  <img src={appGlobal?.LOGO_APP?.value} width={40} />{" "}
                </a>
                {breakpoint === "desktop" && (
                  <div
                    data-v-5f651626=""
                    data-v-0408d032=""
                    id="MicroMenu"
                    className="micro-menu flex items-center relative h-full min-w-[fit-content]"
                  >
                    <div
                      data-v-5f651626=""
                      className="group-menu mr-4px"
                      data-menu-id={96}
                    >
                      <svg
                        data-v-5f651626=""
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.46625 3.45227H4.96629C4.56847 3.45227 4.18695 3.6103 3.90564 3.89161C3.62434 4.17291 3.46631 4.55443 3.46631 4.95226V9.45221C3.46631 9.85003 3.62434 10.2316 3.90564 10.5129C4.18695 10.7942 4.56847 10.9522 4.96629 10.9522H9.46625C9.86407 10.9522 10.2456 10.7942 10.5269 10.5129C10.8082 10.2316 10.9662 9.85003 10.9662 9.45221V4.95226C10.9662 4.55443 10.8082 4.17291 10.5269 3.89161C10.2456 3.6103 9.86407 3.45227 9.46625 3.45227ZM9.46625 9.45221H4.96629V4.95226H9.46625V9.45221ZM19.0103 3.45227H14.5103C14.1125 3.45227 13.731 3.6103 13.4497 3.89161C13.1684 4.17291 13.0103 4.55443 13.0103 4.95226V9.45221C13.0103 9.85003 13.1684 10.2316 13.4497 10.5129C13.731 10.7942 14.1125 10.9522 14.5103 10.9522H19.0103C19.4081 10.9522 19.7896 10.7942 20.0709 10.5129C20.3522 10.2316 20.5103 9.85003 20.5103 9.45221V4.95226C20.5103 4.55443 20.3522 4.17291 20.0709 3.89161C19.7896 3.6103 19.4081 3.45227 19.0103 3.45227ZM19.0103 9.45221H14.5103V4.95226H19.0103V9.45221ZM9.46625 13.0689H4.96629C4.56847 13.0689 4.18695 13.2269 3.90564 13.5082C3.62434 13.7895 3.46631 14.171 3.46631 14.5689V19.0688C3.46631 19.4666 3.62434 19.8482 3.90564 20.1295C4.18695 20.4108 4.56847 20.5688 4.96629 20.5688H9.46625C9.86407 20.5688 10.2456 20.4108 10.5269 20.1295C10.8082 19.8482 10.9662 19.4666 10.9662 19.0688V14.5689C10.9662 14.171 10.8082 13.7895 10.5269 13.5082C10.2456 13.2269 9.86407 13.0689 9.46625 13.0689ZM9.46625 19.0688H4.96629V14.5689H9.46625V19.0688Z"
                          fill="currentColor"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M21.2864 15.9465L18.1045 12.7646C17.8232 12.4833 17.4416 12.3252 17.0438 12.3252C16.646 12.3252 16.2645 12.4833 15.9832 12.7646L12.8012 15.9465C12.5199 16.2278 12.3619 16.6093 12.3619 17.0072C12.3619 17.405 12.5199 17.7865 12.8012 18.0678L15.9832 21.2498C16.2645 21.5311 16.646 21.6891 17.0438 21.6891C17.4416 21.6891 17.8232 21.5311 18.1045 21.2498L21.2864 18.0678C21.5677 17.7865 21.7258 17.405 21.7258 17.0072C21.7258 16.6093 21.5677 16.2278 21.2864 15.9465ZM17.0438 20.1891L13.8619 17.0072L17.0438 13.8252L20.2258 17.0072L17.0438 20.1891Z"
                          fill="var(--group-primary)"
                        />
                      </svg>
                    </div>
                    <Link
                      to="/trading"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={8}
                    >
                      <span data-v-5f651626="" className="title">
                        {t("Mua Crypto")}
                      </span>
                      {/**/}
                    </Link>
                    <Link
                      to="/market"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={13}
                    >
                      <span data-v-5f651626="" className="title">
                        {t("Thị trường")}
                      </span>
                      {/**/}
                    </Link>
                    <Link
                      to="/invest"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={99}
                    >
                      <span
                        data-v-5f651626=""
                        className="title"
                        data-testid="HeaderTradeButton"
                      >
                        {t("Gói đầu tư")}
                      </span>
                      {/**/}
                    </Link>
                    <Link
                      to="/trading-future"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={259}
                    >
                      <span data-v-5f651626="" className="title">
                        Futures
                      </span>
                      {/**/}
                    </Link>
                    <Link
                      to="/trading"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={142}
                    >
                      <span data-v-5f651626="" className="title">
                        {t("Sao chép")}
                      </span>
                      {/**/}
                    </Link>

                    <Link
                      to="/trading"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={53}
                    >
                      <span data-v-5f651626="" className="title">
                        ‌Earn
                      </span>
                      {/**/}
                    </Link>
                    <a
                      href="#"
                      target="_blank"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={88}
                    >
                      <span data-v-5f651626="" className="title">
                        Swap
                      </span>
                      {/**/}
                    </a>
                    <a
                      href="#"
                      target="_blank"
                      data-v-5f651626=""
                      className="text-primaryText menu-item group"
                      data-menu-id={277}
                      style={{}}
                    >
                      <span data-v-5f651626="" className="title">
                        BMC Fund
                      </span>
                      <img
                        data-v-5f651626=""
                        className="tag-img"
                        src="https://img.bitgetimg.com/multiLang/web/07e6ffb7263fb48a0ecadaeee7b1a48c.png"
                        alt=""
                      />
                    </a>
                  </div>
                )}

                <div
                  id="menubar"
                  data-v-0408d032=""
                  className="micro-action flex items-center gap-8px ml-auto h-full"
                >
                  <>
                    {!user && (
                      <>
                        <div className="flex items-center gap-20px whitespace-nowrap pr-8px">
                          <div
                            data-v-29a0c5fa=""
                            className="relative inline-flex items-center h-full login-popover-move"
                          >
                            <div data-v-29a0c5fa="">
                              <Link
                                className="text-primaryText text-16px cursor-pointer leading-40px text-center"
                                to="/login"
                                target="_self"
                                rel="nofollow"
                              >
                                {t("Đăng Nhập")}
                              </Link>
                            </div>
                          </div>
                          <Link
                            className="text-primaryText inline-flex items-center justify-center px-18px h-40px min-w-87px text-16px rounded-20px bg-contentPrimary cursor-pointer !text-contentInversePrimary"
                            to="/register"
                            target="_self"
                            rel="nofollow"
                          >
                            {t("Đăng Ký")}
                          </Link>
                        </div>
                      </>
                    )}
                  </>
                  <div
                    data-v-29a0c5fa=""
                    data-v-d4f89de5=""
                    className="relative inline-flex items-center h-full popover-search"
                  >
                    <div data-v-29a0c5fa="">
                      <div
                        data-v-d4f89de5=""
                        className="inline-flex items-center justify-center w-40px h-40px rounded-50% hover:bg-bgSecondary text-24px cursor-pointer undefined"
                      >
                        <svg
                          data-v-d4f89de5=""
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Search">
                            <path
                              id="Vector"
                              d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                              stroke="currentColor"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              id="Vector_2"
                              d="M21.0343 22.1655C21.3467 22.4779 21.8533 22.4779 22.1657 22.1655C22.4781 21.8531 22.4781 21.3465 22.1657 21.0341L21.0343 22.1655ZM22.1657 21.0341L17.3657 16.2341L16.2343 17.3655L21.0343 22.1655L22.1657 21.0341Z"
                              fill="currentColor"
                            />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                  {user && (
                    <>
                      <div
                        data-v-29a0c5fa=""
                        data-v-cce12880=""
                        className="relative inline-flex items-center h-full"
                      >
                        <div data-v-29a0c5fa="">
                          <Link
                            data-v-cce12880=""
                            className="text-primaryText leading-1 relative"
                            to="/asset"
                            target="_self"
                          >
                            <div
                              data-v-cce12880=""
                              className="flex items-center justify-center w-40px h-40px rounded-50% hover:bg-bgSecondary"
                            >
                              {/**/}
                              <svg
                                data-v-cce12880=""
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="cursor-pointer"
                              >
                                <g id="i-notification">
                                  <path
                                    id="Vector"
                                    d="M21 15H16.0984C14.9398 15 14 13.8803 14 12.5C14 11.1197 14.9398 10 16.0984 10H21"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    id="Vector_2"
                                    d="M8 6L15.5 2L18 6"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    id="Vector_3"
                                    d="M21 18V21H3V6H21"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </g>
                              </svg>
                            </div>
                          </Link>
                        </div>
                        <div
                          data-v-29a0c5fa=""
                          className="popover absolute z-1000 opacity-0 invisible left"
                          lt-md="fixed left-0"
                          style={{ top: "calc(100% - 22px)", paddingTop: 22 }}
                        >
                          {/**/}
                          {/**/}
                        </div>
                      </div>

                      <div
                        className="w-[30px] h-[30px] rounded-full"
                        onClick={() => setIsOpenProfile(true)}
                      >
                        <img
                          src="https://www.bitget.com.vn//baseasset/img/dashboardNew/avatar-default.svg"
                          className="w-full h-full"
                        />
                      </div>
                    </>
                  )}

                  <div className="flex items-center justify-center w-40px h-40px rounded-50% cursor-pointer hover:bg-bgSecondary">
                    {/* <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="cursor-pointer"
                    >
                      <path
                        d="M3 4L21 4"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                      />
                      <path
                        d="M3 12L21 12"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                      />
                      <path
                        d="M3 20L21 20"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                      />
                    </svg> */}
                    <Dropdown
                      menu={{
                        items: [
                          {
                            key: "ms",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("ms")} width={16} alt="" />
                                <span>Malaysia</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "ms");
                              i18n.changeLanguage("ms");
                            },
                          },
                          {
                            key: "vi",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("vi")} width={16} alt="" />
                                <span>Vietnamese</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "vi");
                              i18n.changeLanguage("vi");
                            },
                          },
                          {
                            key: "en",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("en")} width={16} alt="" />
                                <span>English</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "en");
                              i18n.changeLanguage("en");
                            },
                          },
                          {
                            key: "cn",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("cn")} width={16} alt="" />
                                <span>Chinese</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "cn");
                              i18n.changeLanguage("cn");
                            },
                          },
                          {
                            key: "ja",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("ja")} width={16} alt="" />
                                <span>Japanese</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "ja");
                              i18n.changeLanguage("ja");
                            },
                          },
                          {
                            key: "sin",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("sin")} width={16} alt="" />
                                <span>Singapore</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "sin");
                              i18n.changeLanguage("sin");
                            },
                          },
                          
                          {
                            key: "ko",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("ko")} width={16} alt="" />
                                <span>Korea</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "ko");
                              i18n.changeLanguage("ko");
                            },
                          },
                          {
                            key: "thai",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("thai")} width={16} alt="" />
                                <span>Thailand</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "thai");
                              i18n.changeLanguage("thai");
                            },
                          },
                          {
                            key: "cam",
                            label: (
                              <div className="flex items-center gap-1">
                                <img src={getLang("cam")} width={16} alt="" />
                                <span>Campodia</span>
                              </div>
                            ),
                            onClick: () => {
                              localStorage.setItem("lang", "cam");
                              i18n.changeLanguage("cam");
                            },
                          },
                        ],
                      }}
                    >
                      <img src={getLang(i18n.language)} width={24} alt="" />
                    </Dropdown>
                  </div>
                  {/**/}
                </div>
              </div>
              <div data-v-0408d032="" className="bg" />
            </div>
          </div>
        </header>
        <div />
      </div>
    </div>
  );
};

export default Header;
